import { ref, onMounted } from "vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import { useCustomFieldStore } from "./useCustomFieldStore.js";
import ProductNotice from "@/components/ProductNotice.vue";
import UpdateCustomField from "./UpdateCustomField.vue";
import MainHeader from "@/components/MainHeader.vue";
import Loader from "@/components/Loader.vue";
export default {
  name: "FieldMapping",
  uiView: "edit",
  props: {
    state: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    }
  },
  components: {
    LlSecondaryButton,
    Loader,
    MainHeader,
    ProductNotice,
    UpdateCustomField
  },
  setup(props) {
    const loading = ref(false);
    const customFieldLists = ref([]);
    const customFieldNotSet = ref(false);
    const checkProductIsProTrial = ref(false);
    const customFieldStore = useCustomFieldStore();
    customFieldStore.alerts = props.alerts;
    props.userService.me().then(me => {
      checkProductIsProTrial.value = me.features.customFieldMapping;
    });
    const getFieldLists = async () => {
      loading.value = true;
      await customFieldStore.listCustomField();
      loading.value = false;
      customFieldNotSet.value = customFieldStore.customFieldNotSet;
      customFieldLists.value = customFieldStore.customFieldLists;
    };
    const availableOn = customField => {
      const {
        showOnClient,
        showOnMatter,
        showOnInvoice
      } = customField;
      const list = [];
      if (showOnClient) list.push("Client");
      if (showOnMatter) list.push("Matter");
      if (showOnInvoice) list.push("Invoice Memo");
      return list.length ? list.join(", ") : "";
    };
    const updateCustomField = (customFieldId, customField) => {
      if (!checkProductIsProTrial.value) return;
      customFieldStore.showUpdateCustomFieldModal = true;
      customFieldStore.selectedCustomField = customField;
    };
    const createCustomField = () => {
      if (!checkProductIsProTrial.value) return;
      customFieldStore.showUpdateCustomFieldModal = true;
      customFieldStore.selectedCustomField = {};
    };
    onMounted(() => {
      getFieldLists();
    });
    return {
      loading,
      availableOn,
      updateCustomField,
      createCustomField,
      customFieldLists,
      customFieldStore,
      customFieldNotSet,
      getFieldLists
    };
  }
};